import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import { Button, ButtonGroup, Wrapper } from '@farewill/ui'
import { screenMax, screenMin } from '@farewill/ui/helpers/responsive'

import HeroWithImages from 'components/HeroWithImages'
import TrustpilotSummary from 'components/TrustpilotWidget/TrustpilotSummary'

import data from './data'

const buttonStyles = css`
  ${screenMin.m`
    display: inline-flex;
  `}

  ${screenMax.s`
    width: 100%;
  `}
`

const StyledTrustpilotSummary = styled(TrustpilotSummary)`
  ${screenMax.s`
    text-align: left;
  `}
`

const StyledButtonPrimary = styled(Button.Primary)`
  ${buttonStyles}
`

const StyledButtonBordered = styled(Button.Bordered)`
  ${buttonStyles}
`

interface SliceHeroProps {
  ctaText?: string
  title?: string
  subtitle?: string
  maxTitleWidthInColumns?: number
}

const Hero = ({
  ctaText,
  title,
  subtitle,
  maxTitleWidthInColumns,
}: SliceHeroProps): React.ReactElement => (
  <HeroWithImages
    title={title || data.title}
    maxTitleWidthInColumns={maxTitleWidthInColumns}
    subtitle={subtitle || data.subtitle}
    images={data.images}
    additionalContent={
      <>
        <Wrapper>
          <ButtonGroup align="center" horizontalFromS leftToRight>
            {data.ctaLinks.map((ctaLink) => {
              const Component =
                ctaLink.variant === 'bordered'
                  ? StyledButtonBordered
                  : StyledButtonPrimary

              return (
                <Component
                  key={ctaLink.text}
                  type="button"
                  tag={Link}
                  to={ctaLink.to}
                >
                  {ctaText || ctaLink.text}
                </Component>
              )
            })}
          </ButtonGroup>
        </Wrapper>
        <Wrapper margin={['M', 0, 0, 0]} marginFromXL={['L', 0, 0, 0]} centered>
          <StyledTrustpilotSummary />
        </Wrapper>
      </>
    }
  />
)

export default Hero
